const normalizeMaskedPhone = (value: string) => value.replace(/[+()-]/gi, '');

export default normalizeMaskedPhone;
